import { DomainAccess } from 'reactApp/components/SharingWindow/Sharing.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDeleteUserDialog = ({ onActionClick, user }) => {
    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            id: 'delete-user-warning-dialog',
            onActionClick,
            title: `Вы действительно хотите отключить доступ для ${user.email}?`,
            description: `После отключения ${user.email} не сможет просматривать эту папку`,
            buttonAcceptText: 'Отключить',
            buttonRejectText: 'Не отключать',
        },
    });
};

export const renderDeletePublicAccessDialog = ({ onActionClick, domainAccess }) => {
    let title;
    let description;

    switch (domainAccess) {
        case DomainAccess.EMAIL_LIST_ACCESS:
            title = 'Закрыть доступ к файлу?';
            description = 'Текущая ссылка перестанет работать и пользователь не сможет просматривать файл';
            break;
        case DomainAccess.EXTERNAL:
        case DomainAccess.DOMESTIC:
        default:
            title = 'Закрыть персональный\nдоступ к файлу?';
            description = 'Текущая ссылка продолжит работать, но у пользователя пропадёт персональный доступ';
    }

    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            hideCheckbox: true,
            compactButtons: true,
            id: 'delete-public-warning-dialog',
            onActionClick,
            title,
            description,
            buttonAcceptText: 'Закрыть доступ',
            buttonRejectText: 'Не закрывать',
        },
    });
};
